const axios = require("axios")

export const downloadPdf = ({ url, user }, filename) => {
    return new Promise((resolve, reject) => {
        axios.post(process.env.MIX_PDF_GENERATION_URL, { url, user }, {
            auth: { username: process.env.MIX_MICROSERVICE_USER, password: process.env.MIX_MICROSERVICE_PASSWORD },
            responseType: 'blob',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/pdf'
            }
        }).then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename + '.pdf');
            document.body.appendChild(link);
            link.click();

            resolve()
        }).catch(err =>  {
            reject(err)
        })
    });

    
}
